
const advancedSettings = {
  TemplateName: {
    type: "general",
    value: "ReadBarcodes_Default"
  },
  BarcodeFormatIds: {
    type: "general",
    value: [
      "BF_ONED",
      "BF_GS1_DATABAR",
      "BF_PATCHCODE",
      "BF_PDF417",
      "BF_QR_CODE",
      "BF_DATAMATRIX",
      "BF_AZTEC",
      "BF_MAXICODE",
      "BF_GS1_COMPOSITE",
      "BF_USPSINTELLIGENTMAIL",
      "BF_POSTNET",
      "BF_PLANET",
      "BF_AUSTRALIANPOST",
      "BF_RM4SCC",
      "BF_DOTCODE",
      "BF_MICRO_QR",
      "BF_MICRO_PDF417",
    ]
  },
  BarcodeZoneMinDistanceToImageBorders: {
    type: "slider", min: 0, max: 9999, value: 0, description: 'Set the minimum distance (in pixels) between barcode zone and image borders.'
  },
  BinarizationModes: {
    type: "mode",
    modeDisplayCount: 4,
    value: ["BM_LOCAL_BLOCK", "BM_SKIP", "BM_SKIP", "BM_SKIP"],
    description: 'Sets the mode and priority for binarization.',
    options: {
      Skip: { value: "BM_SKIP" },
      LocalBlock: {
        value: "BM_LOCAL_BLOCK",
        args: {
          BlockSizeX: {
            type: "slider",
            min: 0,
            max: 1000,
            value: [0, 0, 0, 0],
            default: [0, 0, 0, 0],
            description: 'Sets the horizontal block size for the binarization process'
          },
          BlockSizeY: {
            type: "slider",
            min: 0,
            max: 1000,
            value: [0, 0, 0, 0],
            default: [0, 0, 0, 0],
            description: 'Sets the vertical block size for the binarization process'
          },
          EnableFillBinaryVacancy: {
            type: "checkbox",
            options: [0, 1],
            value: [1, 1, 1, 1],
            default: [1, 1, 1, 1],
            description: 'Sets whether to enable fill binary vacancy'
          },
          ThresholdCompensation: {
            type: "slider",
            min: -255,
            max: 255,
            value: [10, 10, 10, 10],
            default: [10, 10, 10, 10],
            description: 'Constant subtracted from the mean or weighted mean. Normally, it is positive but may be zero or negative as well.'
          },
        },
      },
      Threshold: {
        value: "BM_THRESHOLD",
        args: {
          BinarizationThreshold: {
            type: "slider",
            min: -1,
            max: 255,
            value: [-1, -1, -1, -1],
            default: [-1, -1, -1, -1],
            description: 'Sets the threshold value which is used to classify the pixel values for binarization processing.'
          }
        },
      },
    },
  },
  DeblurModes: {
    type: "mode",
    modeDisplayCount: 8,
    value: ["DM_SKIP", "DM_SKIP", "DM_SKIP", "DM_SKIP", "DM_SKIP", "DM_SKIP", "DM_SKIP", "DM_SKIP"],
    description: 'DeblurModes is a parameter for setting the mode for deblurring. It consisits of one or more DeblurMode items. The array index represents the priority of the item. The smaller index is, the higher priority is.',
    options: {
      Skip: { value: "DM_SKIP" },
      DirectBinarization: { value: "DM_DIRECT_BINARIZATION" },
      ThresholdBinarization: { value: "DM_THRESHOLD_BINARIZATION" },
      GrayEqualization: { value: "DM_GRAY_EQUALIZATION" },
      Smoothing: { value: "DM_SMOOTHING" },
      Morphing: { value: "DM_MORPHING" },
      DeepAnalysis: { value: "DM_DEEP_ANALYSIS" },
      Sharpening: { value: "DM_SHARPENING" },
      BasedOnLocBin: { value: "DM_BASED_ON_LOC_BIN" },
      SharpeningSmoothing: { value: "DM_SHARPENING_SMOOTHING" },
    },
  },
  EnableQRCodeModel1: {
    type: "checkbox",
    value: 0,
    description: 'Sets whether or not to decode QR Code generated with model 1.'
  },
  ExpectedBarcodesCount: {
    type: "general",
    value: 999
  },
  LocalizationModes: {
    type: "mode",
    modeDisplayCount: 8,
    value: ["LM_CONNECTED_BLOCKS", "LM_SCAN_DIRECTLY", "LM_STATISTICS", "LM_LINES", "LM_SKIP", "LM_SKIP", "LM_SKIP", "LM_SKIP"],
    description: 'Sets the mode and priority for localization algorithms.',
    options: {
      Skip: { value: "LM_SKIP" },
      Centre: {
        value: "LM_CENTRE",
        args: {
          ModuleSize: {
            type: "slider",
            min: 0,
            max: 99999,
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            default: [0, 0, 0, 0, 0, 0, 0, 0]
          },
        },
      },
      OneDFastScan: {
        value: "LM_ONED_FAST_SCAN",
        args: {
          ScanStride: {
            type: "slider",
            min: 0,
            max: 999,
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            default: [0, 0, 0, 0, 0, 0, 0, 0],
            description: 'Sets the stride in pixel between scans when searching barcode.'
          },
          ScanDirection: {
            type: "slider",
            min: 0,
            max: 2,
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            default: [0, 0, 0, 0, 0, 0, 0, 0],
            description: 'Sets the scan direction when searching barcode.'
          },
          ConfidenceThreshold: {
            type: "slider",
            min: 0,
            max: 100,
            value: [60, 60, 60, 60, 60, 60, 60, 60],
            default: [60, 60, 60, 60, 60, 60, 60, 60],
            description: 'Sets the confidence threshold.'
          }
        }
      },
      ConnectedBlocks: { value: "LM_CONNECTED_BLOCKS" },
      Lines: { value: "LM_LINES" },
      ScanDirectly: {
        value: "LM_SCAN_DIRECTLY",
        args: {
          ScanStride: {
            type: "slider",
            min: 0,
            max: 999,
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            default: [0, 0, 0, 0, 0, 0, 0, 0],
            description: 'Sets the stride in pixel between scans when searching barcode.'
          },
          ScanDirection: {
            type: "slider",
            min: 0,
            max: 2,
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            default: [0, 0, 0, 0, 0, 0, 0, 0],
            description: 'Sets the scan direction when searching barcode.'
          },
          IsOneDStacked: {
            type: "checkbox",
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            default: [0, 0, 0, 0, 0, 0, 0, 0],
            description: 'Process stacked OneD barcodes.'
          }
        },
      },
      Statistics: { value: "LM_STATISTICS" },
      StatisticsMarks: { value: "LM_STATISTICS_MARKS" },
      StatisticsPostalCode: { value: "LM_STATISTICS_POSTAL_CODE" },
    }
  },
  MaxThreadsInOneTask: {
    type: "slider",
    min: 1,
    max: 4,
    value: 4,
    description: 'Defines the maximum threads that can be consumed in one task.'
  },
  MinResultConfidence: {
    type: "slider",
    min: 0,
    max: 100,
    value: 30,
    description: 'The minimum confidence of the result.'
  },
  PDFRasterDPI: {
    type: "slider",
    min: 100,
    max: 600,
    value: 300,
    description: 'Sets the output image resolution. When you are trying to decode a PDF file using DecodeFile method, the library will convert the pdf file to image(s) first, then perform barcode recognition. To ensure your barcodes in the PDF files are readable, please set the resolution to at least 300 dpi'
  },
  PDFReadingMode: {
    type: "general",
    modeDisplayCount: 1,
    value: [0x02],
    options: { "PDFRM_RASTER": { value: 0x02 }, "PDFRM_VECTOR": { value: 0x01 } },
    style: { display: "flex", justifyContent: "center", alignItems: "center" }
  },
  Region: {
    type: "region",
    value: null as null | Region_2,
    description: 'Set the area for decoding.'
  },
  ScaleDownThreshold: {
    type: "slider",
    min: 512,
    max: 99999,
    value: 2300,
    description: 'Sets the threshold for the image shrinking. If the shorter edge size is larger than the given value, the library will calculate the required height and width of the barcode image and shrink the image to that size before localization. Otherwise, it will perform barcode localization on the original image. If you have an image whose shorter edge size is larger than the given value and the barcode is a small part on it, you can set this value to be larger than the shorter edge of this image. If you have an image whose shorter edge size is larger than the given value and the barcode is clear and big, you can set this value to a smaller one than the default value.'
  },
  ScaleUpModes: {
    type: "mode",
    modeDisplayCount: 4,
    value: ["SUM_AUTO", "SUM_SKIP", "SUM_SKIP", "SUM_SKIP"],
    description: "Sets the mode and priority to control the sampling methods of scale-up for linear barcodes with small module sizes.",
    options: {
      Skip: { value: "SUM_SKIP" },
      Auto: { value: "SUM_AUTO" },
      LinearInterpolation: {
        value: "SUM_LINEAR_INTERPOLATION",
        args: {
          AcuteAngleWithXThreshold: {
            type: "slider",
            min: -1,
            max: 90,
            value: [-1, -1, -1, -1],
            default: [-1, -1, -1, -1],
            description: "Sets the acute angle threshold for scale-up."
          },
          ModuleSizeThreshold: {
            type: "slider",
            min: 0,
            max: 999,
            value: [0, 0, 0, 0],
            default: [0, 0, 0, 0],
            description: "Sets the module size threshold for scale-up."
          },
          TargetModuleSize: {
            type: "slider",
            min: 0,
            max: 10,
            value: [0, 0, 0, 0],
            default: [0, 0, 0, 0],
            description: "Sets the target module size to scale up."
          },
        },
      },
      NearestNeighbourInterpolation: {
        value: "SUM_NEAREST_NEIGHBOUR_INTERPOLATION",
        args: {
          AcuteAngleWithXThreshold: {
            type: "slider",
            min: -1,
            max: 90,
            value: [-1, -1, -1, -1],
            default: [-1, -1, -1, -1],
            description: "Sets the acute angle threshold for scale-up."
          },
          ModuleSizeThreshold: {
            type: "slider",
            min: 0,
            max: 999,
            value: [0, 0, 0, 0],
            default: [0, 0, 0, 0],
            description: "Sets the module size threshold for scale-up."
          },
          TargetModuleSize: {
            type: "slider",
            min: 0,
            max: 10,
            value: [0, 0, 0, 0],
            default: [0, 0, 0, 0],
            description: "Sets the target module size to scale up."
          },
        },
      },
    },
  },
  TextResultOrderModes: {
    type: "mode",
    modeDisplayCount: 4,
    value: ["TROM_CONFIDENCE", "TROM_POSITION", "TROM_FORMAT", "TROM_SKIP"],
    options: { Skip: { value: "TROM_SKIP" }, Confidence: { value: "TROM_CONFIDENCE" }, Position: { value: "TROM_POSITION" }, Format: { value: "TROM_FORMAT" } },
    description: 'Sets the mode and priority for the order of the text results returned.'
  },
  Timeout: {
    type: "slider",
    value: 10000,
    min: 100,
    max: 99999,
    description: 'Sets the maximum amount of time (in milliseconds) that should be spent searching for a barcode per page. It does not include the time taken to load/decode an image (Tiff, PNG, etc) from disk into memory. If you want to stop reading barcodes after a specified amount of time, you can use this parameter to set a timeout.'
  },
  FurtherModes: {
    type: "inside",
    description: 'More settings',
    inside: {
      BarcodeColourModes: {
        type: "mode",
        modeDisplayCount: 4,
        value: ["BICM_SKIP", "BICM_SKIP", "BICM_SKIP", "BICM_SKIP"],
        description: 'Sets the mode and priority for the barcode colour mode used to process the barcode zone.',
        options: {
          Skip: { value: "BICM_SKIP" },
          DarkOnLight: {
            value: "BICM_DARK_ON_LIGHT",
            args: {
              LightReflection: {
                type: "checkbox",
                options: [0, 1],
                value: [1, 1, 1, 1],
                default: [1, 1, 1, 1],
                description: 'Set if there is light reflection on the barocde zone.'
              },
            },
          },
          LightOnDark: {
            value: "BICM_LIGHT_ON_DARK",
            args: {
              LightReflection: {
                type: "checkbox",
                options: [0, 1],
                value: [1, 1, 1, 1],
                default: [1, 1, 1, 1],
              },
            },
          },
          DarkOnDark: {
            value: "BICM_DARK_ON_DARK",
            args: {
              LightReflection: {
                type: "checkbox",
                options: [0, 1],
                value: [1, 1, 1, 1],
                default: [1, 1, 1, 1],
              },
            },
          },
          LightOnLight: {
            value: "BICM_LIGHT_ON_LIGHT",
            args: {
              LightReflection: {
                type: "checkbox",
                options: [0, 1],
                value: [1, 1, 1, 1],
                default: [1, 1, 1, 1],
              },
            },
          },
          DarkLightMixed: {
            value: "BICM_DARK_LIGHT_MIXED",
            args: {
              LightReflection: {
                type: "checkbox",
                options: [0, 1],
                value: [1, 1, 1, 1],
                default: [1, 1, 1, 1],
              },
            },
          },
          DarkOnLightDarkSurrounding: {
            value: "BICM_DARK_ON_LIGHT_DARK_SURROUNDING",
            args: {
              LightReflection: {
                type: "checkbox",
                options: [0, 1],
                value: [1, 1, 1, 1],
                default: [1, 1, 1, 1],
              },
            },
          },
        },
      },
      BarcodeComplementModes: {
        type: "mode",
        modeDisplayCount: 4,
        value: new Array(4).fill("BCM_SKIP"),
        options: { Skip: { value: "BCM_SKIP" }, Auto: { value: "BCM_AUTO" }, General: { value: "BCM_GENERAL" } },
        description: 'Sets the mode and priority to complement the missing parts in the barcode.'
      },
      ColourConversionModes: {
        type: "mode",
        modeDisplayCount: 4,
        value: ["CICM_GENERAL", "CICM_SKIP", "CICM_SKIP", "CICM_SKIP"],
        description: 'Sets the mode and priority for converting a colour image to a grayscale image.',
        options: {
          Skip: { value: "CICM_SKIP" },
          General: {
            value: "CICM_GENERAL",
            args: {
              BlueChannelWeight: {
                type: "slider",
                min: -1,
                max: 1000,
                value: [-1, -1, -1, -1],
                default: [-1, -1, -1, -1],
                description: "Set the weight value of Blue Colour Channel used for converting a colour image to a grayscale image."
              },
              GreenChannelWeight: {
                type: "slider",
                min: -1,
                max: 1000,
                value: [-1, -1, -1, -1],
                default: [-1, -1, -1, -1],
                description: "Set the weight value of Green Colour Channel used for converting a colour image to a grayscale image."
              },
              RedChannelWeight: {
                type: "slider",
                min: -1,
                max: 1000,
                value: [-1, -1, -1, -1],
                default: [-1, -1, -1, -1],
                description: "Set the weight value of Red Colour Channel used for converting a colour image to a grayscale image"
              },
            },
          },
          HSV: {
            value: "CICM_HSV",
          }
        },
      },
      DPMCodeReadingModes: {
        type: "general",
        value: ["DPMCRM_SKIP", "DPMCRM_SKIP", "DPMCRM_SKIP", "DPMCRM_SKIP", "DPMCRM_SKIP", "DPMCRM_SKIP", "DPMCRM_SKIP", "DPMCRM_SKIP"]
      },
      DeformationResistingModes: {
        type: "mode",
        modeDisplayCount: 4,
        value: new Array(4).fill("DRM_SKIP"),
        description: 'Sets the mode and priority for deformation resisting.',
        options: {
          Skip: { value: "DRM_SKIP" },
          Auto: { value: "DRM_AUTO" },
          General: {
            value: "DRM_GENERAL",
            args: {
              Level: {
                type: "slider",
                min: 1,
                max: 9,
                value: [5, 5, 5, 5],
                default: [5, 5, 5, 5],
              },
            },
          },
          BroadWarp: { value: "DRM_BROAD_WARP" },
          LocalReference: { value: "DRM_LOCAL_REFERENCE" },
          Dewrinkle: { value: "DRM_DEWRINKLE" },
        },
      },
      GrayscaleEnhancementModes: {
        type: "mode",
        modeDisplayCount: 4,
        value: ["GEM_GENERAL", "GEM_SKIP", "GEM_SKIP", "GEM_SKIP"],
        description: "Parameter GrayscaleEnhancementModes provides some image processing methods to enhance the quality of the grayscale image. By default, the library does no image preprocessing. Assume your image has distorted features that can be solved by common image processing methods, this parameter can help you get a higher quality grayscale image by shifting the order of the preprocessing algorithms used (if at all).",
        options: {
          Skip: { value: "GEM_SKIP" },
          General: { value: "GEM_GENERAL" },
          GrayEqualize: {
            value: "GEM_GRAY_EQUALIZE",
            args: {
              Sensitivity: {
                type: "slider",
                min: 1,
                max: 9,
                value: [5, 5, 5, 5],
                default: [5, 5, 5, 5]
              }
            }
          },
          GraySmooth: {
            value: "GEM_GRAY_SMOOTH",
            args: {
              SmoothBlockSizeX: {
                type: "slider",
                min: 3,
                max: 1000,
                value: [3, 3, 3, 3],
                default: [3, 3, 3, 3]
              },
              SmoothBlockSizeY: {
                type: "slider",
                min: 3,
                max: 1000,
                value: [3, 3, 3, 3],
                default: [3, 3, 3, 3]
              }
            }
          },
          SharpenSmooth: {
            value: "GEM_SHARPEN_SMOOTH",
            args: {
              SmoothBlockSizeX: {
                type: "slider",
                min: 3,
                max: 1000,
                value: [3, 3, 3, 3],
                default: [3, 3, 3, 3]
              },
              SmoothBlockSizeY: {
                type: "slider",
                min: 3,
                max: 1000,
                value: [3, 3, 3, 3],
                default: [3, 3, 3, 3]
              },
              SharpenBlockSizeX: {
                type: "slider",
                min: 3,
                max: 1000,
                value: [3, 3, 3, 3],
                default: [3, 3, 3, 3]
              },
              SharpenBlockSizeY: {
                type: "slider",
                min: 3,
                max: 1000,
                value: [3, 3, 3, 3],
                default: [3, 3, 3, 3]
              }
            }
          }
        }
      },
      GrayscaleTransformationModes: {
        type: "general",
        value: ["GTM_ORIGINAL", "GTM_INVERTED", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO"]
      },
      RegionPredetectionModes: {
        type: "mode",
        modeDisplayCount: 4,
        value: ["RPM_GENERAL", "RPM_SKIP", "RPM_SKIP", "RPM_SKIP"],
        description: 'Sets the region pre-detection mode for barcodes search.',
        options: {
          Skip: { value: "RPM_SKIP" },
          Auto: { value: "RPM_AUTO" },
          General: { value: "RPM_GENERAL" },
          RGB: {
            value: "RPM_GENERAL_RGB_CONTRAST",
            args: {
              MinImageDimension: {
                type: "slider",
                min: 262144,
                max: 0x7fffffff,
                value: [262144, 262144, 262144, 262144],
                default: [262144, 262144, 262144, 262144],
              },
              Sensitivity: {
                type: "slider",
                min: 1,
                max: 9,
                value: [1, 1, 1, 1],
                default: [1, 1, 1, 1]
              },
              SpatialIndexBlockSize: {
                type: "slider",
                min: 1,
                max: 32,
                value: [5, 5, 5, 5],
                default: [5, 5, 5, 5],
              },
              //ForeAndBackgroundColours: { type: "string", value: "", default: "" },
            },
          },
          Gray: {
            value: "RPM_GENERAL_GRAY_CONTRAST",
            args: {
              MinImageDimension: {
                type: "slider",
                min: 262144,
                max: 0x7fffffff,
                value: [262144, 262144, 262144, 262144],
                default: [262144, 262144, 262144, 262144],
              },
              Sensitivity: {
                type: "slider",
                min: 1,
                max: 9,
                value: [1, 1, 1, 1],
                default: [1, 1, 1, 1]
              },
              SpatialIndexBlockSize: {
                type: "slider",
                min: 1,
                max: 32,
                value: [5, 5, 5, 5],
                default: [5, 5, 5, 5],
              },
              //ForeAndBackgroundColours: { type: "string", value: "", default: "" },
            },
          },
          HSV: {
            value: "RPM_GENERAL_HSV_CONTRAST",
            args: {
              MinImageDimension: {
                type: "slider",
                min: 262144,
                max: 0x7fffffff,
                value: [262144, 262144, 262144, 262144],
                default: [262144, 262144, 262144, 262144],
              },
              Sensitivity: {
                type: "slider",
                min: 1,
                max: 9,
                value: [1, 1, 1, 1],
                default: [1, 1, 1, 1]
              },
              SpatialIndexBlockSize: {
                type: "slider",
                min: 1,
                max: 32,
                value: [5, 5, 5, 5],
                default: [5, 5, 5, 5],
              },
              //ForeAndBackgroundColours: { type: "string", value:"", default: "" },
            },
          },
        },
      },
      TextureDetectionModes: {
        type: "mode",
        modeDisplayCount: 4,
        value: ["TDM_GENERAL_WIDTH_CONCENTRATION", "TDM_SKIP", "TDM_SKIP", "TDM_SKIP"],
        description: 'Sets the mode and priority for texture detection.',
        options: {
          Skip: { value: "TDM_SKIP" },
          GeneralWidthConcentration: {
            value: "TDM_GENERAL_WIDTH_CONCENTRATION",
            args: {
              Sensitivity: {
                type: "slider",
                min: 1,
                max: 9,
                value: [5, 5, 5, 5],
                default: [5, 5, 5, 5],
                description: 'Sets the sensitivity used for texture detection'
              },
            },
          },
        },
      },
    },
  },
};

export default advancedSettings;

export type TemplateName = "ReadBarcodes_Default" | "ReadBarcodes_ReadRateFirst" | "ReadBarcodes_SpeedFirst";

export type Region_2 = {
  RegionTop: number;
  RegionLeft: number;
  RegionRight: number;
  RegionBottom: number;
  RegionMeasuredByPercentage: number;
}